export default __webpack_public_path__ + "static/media/CGV_MUSTANG_BONDY.b8c3c508.pdf";